module.exports = __webpack_public_path__ + "static/media/cardThird.bc3f7bdd.png";